export default "__VITE_ASSET__DPz_q7BW__"